// src/modules/app-views/ticket-events/pages/Document/tabs/RecordTab/EventInfoCard.jsx
import { Card, Col, Row } from 'antd';
import translateX from 'utils/translateX';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';
import SimpleNumber from 'components/SimpleComponents/SimpleNumber';
import SimpleCurrency from 'components/SimpleComponents/SimpleCurrency';
import SimpleRangePicker from 'components/SimpleComponents/SimpleRangePicker';
import SimpleDatePicker from 'components/SimpleComponents/SimpleDatePicker';

const STATUS_OPTIONS = [
  { value: 'draft', labelKey: 'draft' },
  { value: 'active', labelKey: 'active' },
  { value: 'paused', labelKey: 'paused' },
  { value: 'ended', labelKey: 'ended' },
  { value: 'sold-out', labelKey: 'sold_out' },
];

const BRL_CURRENCY = [{ value: 'BRL', label: 'R$', text: 'Real Brasileiro' }];

const EventInfoCard = () => {
  return (
    <Card title={<div className="text-muted">{translateX('event_info')}</div>}>
      <Row gutter={ROW_GUTTER}>
        <Col xs={24} sm={16}>
          <SimpleInput
            name="name"
            label={translateX('event_name')}
          />
        </Col>
        <Col xs={24} sm={8}>
          <SimpleSelect
            name="status"
            label={translateX('status')}
            options={STATUS_OPTIONS}
          />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        <Col xs={24}>
          <SimpleTextArea
            name="description"
            label={translateX('description')}
            rows={2}
          />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        <Col xs={24} sm={8}>
          <SimpleNumber
            name="totalTickets"
            label={translateX('total_tickets')}
            min={1}
          />
        </Col>
        <Col xs={24} sm={8}>
          <SimpleCurrency
            name="minimumPrice"
            label={translateX('minimum_price')}
            currencies={BRL_CURRENCY}
          />
        </Col>
        <Col xs={24} sm={8}>
          <SimpleCurrency
            name="maximumPrice"
            label={translateX('maximum_price')}
            currencies={BRL_CURRENCY}
          />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        <Col xs={24} sm={16}>
          <SimpleRangePicker
            name="salePeriod"
            label={`${translateX('sale_start')} / ${translateX('sale_end')}`}
            showTime
            format="DD/MM/YYYY HH:mm"
          />
        </Col>
        <Col xs={24} sm={8}>
          <SimpleDatePicker
            name="eventDate"
            label={translateX('event_date')}
            showTime
            format="DD/MM/YYYY HH:mm"
          />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        <Col xs={24}>
          <SimpleTextArea
            name="note"
            label={translateX('note')}
            rows={2}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default EventInfoCard;
